/**
 * v2/index.js
 * Autogenerated via generateMockRouteIndexes.js
 * DO NOT MODIFY THIS FILE DIRECTLY.
 */

import clinician from './clinician';
import clinicians from './clinicians';

/** @type {import('../../mockRequestHandler').EndpointMockConfig} */
export default {
  ...clinician,
  ...clinicians
};
